import { BarChart3, Bot, CalendarClock, CircleCheck, ClipboardList, Layers, ListChecks, Repeat, type LucideIcon } from "lucide-react"

/** Icons a program's landing page can use for its feature cards. */
export const PROGRAM_ICONS: { value: string; label: string; icon: LucideIcon }[] = [
  { value: "check", label: "Checkmark", icon: CircleCheck },
  { value: "layers", label: "Layers", icon: Layers },
  { value: "repeat", label: "Repeat", icon: Repeat },
  { value: "list-checks", label: "Checklist", icon: ListChecks },
  { value: "clipboard-list", label: "Clipboard", icon: ClipboardList },
  { value: "bot", label: "Assistant", icon: Bot },
  { value: "bar-chart", label: "Chart", icon: BarChart3 },
  { value: "calendar", label: "Calendar", icon: CalendarClock },
]

export function programIcon(name: string): LucideIcon {
  return PROGRAM_ICONS.find((i) => i.value === name)?.icon ?? CircleCheck
}
